import React from 'react';
import { Modal, Tabs } from 'antd';
import AddTourGeneralForm from '../Forms/AddTourGeneralForm.js';

const { TabPane } = Tabs;

const AddTourContainer = ({ state, user, ...props }) => {

  return(
    <Modal
      open={state.showItemContextModal}
      title={props.contextMenuSelection}
      onCancel={props.handleModalCancel}
      footer={[
      ]}
    >
      <Tabs defaultActiveKey="1">
          <TabPane tab={<p>General</p>} key="1">
            <AddTourGeneralForm
              loading={state.loading}
              resource={state.resource}
              itemDetails={state.itemDetails}
              user={user}
              confirmDialogue={state.confirmDialogue}
              handleTourDurationChange={props.handleTourDurationChange}
              handleTourStartTimeChange={props.handleTourStartTimeChange}
              handleTourEndTimeChange={props.handleTourEndTimeChange}
              handleMealStartTimeChange={props.handleMealStartTimeChange}
              handleMealEndTimeChange={props.handleMealEndTimeChange}
              handleOmnibusFieldChange={props.handleOmnibusFieldChange}
              createTour={props.createTour}
            />
          </TabPane>
      </Tabs>
    </Modal>
  )
}

export default AddTourContainer;
